import z from 'zod';
import { guestSchema } from './Guest.schema';
export const SpaExtrasSchema = z
  .array(
    z.object({
      extra: z.object({ id: z.number() }),
      selectedGuestDetails: z.array(guestSchema),
      priceAmount: z.number(),
    })
  )
  .optional();

export type OvernightPackageSpaExtras = z.infer<typeof SpaExtrasSchema>;
